import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import EchoUsername from "./EchoUsername";
import { formatTextWithLinks } from "../utils/formatText";
import MentionTextarea from "./MentionTextarea";
import Swal from 'sweetalert2';
import '../Profile.css';


const PostComments = ({ post }) => {
    const [comments, setComments] = useState([]);
    const [likes, setLikes] = useState({});
    const [userLiked, setUserLiked] = useState([]);
    const [showAll, setShowAll] = useState(false);
    const [newComment, setNewComment] = useState('');
    const [loading, setLoading] = useState(false);
    const textareaRef = React.useRef(null);


    const maxVisible = 3;
    const echoUser = localStorage.getItem('echo_user');
    const fwUser = localStorage.getItem('fw_user');
    const echoUserData = localStorage.getItem('fw_user_lvl') || 1;
    const handleDelete = async (commentId) => {
        const result = await Swal.fire({
            title: 'Smazat komentář?',
            text: 'Tato akce je nevratná!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#aaa',
            confirmButtonText: 'Ano, smazat',
            cancelButtonText: 'Zrušit',
        });

        if (result.isConfirmed) {
            try {
                const res = await fetch('https://api.fantasyworldtrpg.cz/echo/delete_comment.php', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ comment: commentId, user: fwUser, char: echoUser })
                });

                const data = await res.json();
                if (data.status === 'success') {
                    setComments(prev => prev.filter(c => c.id !== commentId));
                    Swal.fire('Smazáno!', 'Komentář byl úspěšně smazán.', 'success');
                } else {
                    Swal.fire('Chyba!', 'Nepodařilo se smazat komentář.', 'error');
                }
            } catch (err) {
                console.error("Chyba při mazání komentáře:", err);
                Swal.fire('Chyba!', 'Nastala chyba při mazání komentáře.', 'error');
            }
        }
    };


    const fetchComments = async () => {
        try {
            const res = await fetch('https://api.fantasyworldtrpg.cz/echo/comments.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ post: post.id }),
            });
            const data = await res.json();
            if (data.status === 'success') {
                setComments(data.comments);
            }
        } catch (err) {
            console.error('Chyba při načítání komentářů:', err);
        }
    };

    const fetchLikes = async () => {
        try {
            const res = await fetch('https://api.fantasyworldtrpg.cz/echo/comment_likes.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ post: post.id, user: echoUser }),
            });
            const data = await res.json();
            if (data.status === 'success') {
                setLikes(data.likes || {});
                setUserLiked(data.liked || []);
            }
        } catch (err) {
            console.error('Chyba při načítání lajků:', err);
        }
    };

    const handleLike = async (commentId) => {
        try {
            const res = await fetch('https://api.fantasyworldtrpg.cz/echo/toggle_comment_like.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ comment: commentId, user: echoUser }),
            });
            const data = await res.json();
            if (data.status === 'added' || data.status === 'removed') {
                fetchLikes();
            }
        } catch (err) {
            console.error('Chyba při přepínání lajku:', err);
        }
    };

    const handleSubmit = async () => {
        if (newComment.trim() === '') return;

        setLoading(true);
        try {
            const res = await fetch('https://api.fantasyworldtrpg.cz/echo/add_comment.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    post: post.id,
                    user: echoUser,
                    text: newComment.trim()
                }),
            });

            const data = await res.json();
            if (data.status === 'success' && data.comment) {
                setComments(prev => [...prev, data.comment]);
                setNewComment('');
            }
        } catch (err) {
            console.error('Chyba při odesílání komentáře:', err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchComments();
        fetchLikes();
    }, [post.id]);

    const handleReply = (nickname) => {
        const tag = `@${nickname} `;
        setNewComment((prev) => (prev.startsWith(tag) ? prev : tag + prev));
        setTimeout(() => {
            textareaRef.current?.focus();
        }, 0);
    };


    const visibleComments = showAll ? comments : comments.slice(0, maxVisible);

    return (
        <div className="mt-3">
            {/* Komentáře */}
            {visibleComments.map((c, index) => (
                <div key={index} className="d-flex mb-2">
                    <div className="rounded-circle me-2" style={{width: '40px', height: '40px', position: 'relative', overflow: 'hidden'}}>
                        {c.vip_frame ? (
                            <div className={`rounded-circle ${c.vip_frame ? `vip-frame-${c.vip_frame}-little` : ''}`} style={{width: '100%', height: '100%', position: 'relative', overflow: 'hidden'}}>
                                <img
                                    src={c.avatar}
                                    alt={c.username}
                                    className="rounded-circle"
                                    style={{ width: '100%', height: '100%', objectFit: 'cover', position: 'relative', zIndex: 2 }}
                                />
                            </div>
                        ) : (
                            <img
                                src={c.avatar}
                                alt={c.username}
                                className="rounded-circle"
                                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                            />
                        )}
                    </div>

                    <div>
                        <EchoUsername userId={c.userId} name={c.username} accountType={c.account_type} />
                        <div className="mb-1">{formatTextWithLinks(c.text)}</div>
                        <span
                            onClick={() => handleLike(c.id)}
                            style={{
                                cursor: 'pointer',
                                color: userLiked.includes(c.id) ? 'red' : '#999',
                                fontSize: '1.1rem'
                            }}
                        >
                            ❤️ {likes[c.id] || 0}
                        </span>
                        <span
                            title={`Odpověz uživateli ${c.nickname}`}
                            style={{cursor: 'pointer'}}
                            className="ms-2"
                            onClick={() => handleReply(c.nickname)}
                        >
                            <i className="bi bi-chat-left-quote-fill"></i>
                        </span>
                        {(c.userId === echoUser || echoUserData > 1) && (
                            <span
                                className="ms-2 text-danger"
                                style={{ cursor: 'pointer' }}
                                title="Smazat komentář"
                                onClick={() => handleDelete(c.id)}
                            >
                                <i className="bi bi-trash-fill"></i>
                            </span>
                        )}

                    </div>
                </div>
            ))}

            {/* Zobrazit vše */}
            {comments.length > maxVisible && !showAll && (
                <button className="btn btn-sm btn-link mt-2" onClick={() => setShowAll(true)}>
                    Zobrazit všechny komentáře ({comments.length})
                </button>
            )}

            {/* Vložení komentáře */}
            {post.locked == 0 ? (
                <div className="d-flex align-items-start gap-2 mt-3">
                    <MentionTextarea
                        ref={textareaRef}
                        value={newComment}
                        onChange={setNewComment}
                        placeholder="Napiš komentář..."
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' && !e.shiftKey) {
                                e.preventDefault();
                                handleSubmit();
                            }
                        }}
                    />

                    <button
                        className="btn btn-danger"
                        disabled={loading || newComment.trim() === ''}
                        onClick={handleSubmit}
                    >
                        {loading ? 'Odesílání...' : 'Odeslat'}
                    </button>
                </div>
            ) : (<div className="text-center text-secondary">Vypnuté komentáře</div>)}
        </div>
    );
};

export default PostComments;
